const STATE_KEY = 'azure_oauth_state';

export function startAzureLogin() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  const state = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  sessionStorage.setItem(STATE_KEY, state);
  const params = new URLSearchParams({
    client_id: process.env.VUE_APP_AZURE_CLIENT_ID,
    response_type: 'code',
    redirect_uri: process.env.VUE_APP_AZURE_REDIRECT_URI,
    response_mode: 'query',
    scope: 'openid profile email User.Read',
    state,
  });
  window.location.href =
    `https://login.microsoftonline.com/${process.env.VUE_APP_AZURE_TENANT_ID}/oauth2/v2.0/authorize?${params}`;
}

export function consumeAzureState(state) {
  const expected = sessionStorage.getItem(STATE_KEY);
  sessionStorage.removeItem(STATE_KEY);
  return !!expected && expected === state;
}
